import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "setup-empty rounded-catering-md border border-catering-cream-400 px-8 py-11 text-center font-catering-body"
}
const _hoisted_2 = {
  key: 0,
  class: "setup-empty__seal mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-catering-lemon shadow-catering-accent"
}
const _hoisted_3 = {
  key: 1,
  class: "mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-catering-sm border border-catering-cream-400 bg-catering-cream-50 text-catering-ink-400"
}
const _hoisted_4 = { class: "font-catering-display text-[25px] leading-tight text-catering-ink-900" }
const _hoisted_5 = { class: "mx-auto mt-2 max-w-[27rem] text-sm leading-relaxed text-catering-ink-600" }
const _hoisted_6 = { class: "mx-auto mt-6 flex w-max max-w-full flex-col gap-2.5 text-left" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "mt-6 flex justify-center" }
const _hoisted_9 = ["href"]

import { GlobeAltIcon } from '@heroicons/vue/24/outline'
import { CheckIcon, ClockIcon } from '@heroicons/vue/24/solid'
import { computed } from 'vue'

import GlowFrame from '@/components/catering/GlowFrame.vue'
import Sheet from '@/components/catering/Sheet.vue'
import SwooshArrow from '@/components/catering/SwooshArrow.vue'
import NeueButton from '@/components/neue/NeueButton.vue'
import { neueButtonClasses } from '@/components/neue/neueButtonClasses'
import { isSettledTone, setupEmptyStateCopy } from '@/components/setup/setupSurfaceCopy'
import { useSetupSurface } from '@/components/setup/useSetupSurface'
import { useStorefrontLink } from '@/components/setup/useStorefrontLink'


export default {
  __name: 'SetupEmptyState',
  setup(__props) {

const { visible, surface, open } = useSetupSurface()
const { host, url, canCopy, copied, copy: copyLink } = useStorefrontLink()

const copy = computed(() => setupEmptyStateCopy(surface.value))

// The link answers a different question from the seal above it. This one is
// whether checkout is open, which is what the copy is talking about when it tells
// the merchant to share it, so it is read off the copy. The seal means nothing
// outstanding and follows complete, the way the sidebar badge's tick does.
const checkoutOpen = computed(() => isSettledTone(copy.value.tone))

return (_ctx, _cache) => {
  return (_unref(visible))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(surface).complete)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createVNode(_unref(CheckIcon), { class: "h-6 w-6 text-catering-ink-900" })
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _createVNode(_unref(ClockIcon), { class: "h-6 w-6" })
            ])),
        _createElementVNode("h3", _hoisted_4, _toDisplayString(copy.value.title), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(copy.value.body), 1),
        _createElementVNode("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(surface).tasks, (task) => {
            return (_openBlock(), _createElementBlock("li", {
              key: task.key,
              class: "flex items-center gap-2.5 text-[13.5px]"
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["flex h-[19px] w-[19px] flex-none items-center justify-center rounded-[6px] border", 
            task.complete
              ? 'border-catering-ink-900 bg-catering-ink-900 text-catering-lemon'
              : 'border-catering-cream-500 bg-catering-cream-50'
          ])
              }, [
                (task.complete)
                  ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                      key: 0,
                      class: "h-3 w-3"
                    }))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("span", {
                class: _normalizeClass(task.complete ? 'text-catering-ink-400 line-through' : 'font-semibold text-catering-ink-700')
              }, _toDisplayString(task.label), 3)
            ]))
          }), 128))
        ]),
        (checkoutOpen.value && _unref(url))
          ? (_openBlock(), _createBlock(Sheet, {
              key: 2,
              variant: "ink",
              class: "mx-auto mt-6 inline-flex items-center gap-2.5 py-2.5"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(GlobeAltIcon), { class: "h-[18px] w-[18px]" }),
                _createElementVNode("a", {
                  href: _unref(url),
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "font-catering-mono text-sm hover:underline"
                }, _toDisplayString(_unref(host)), 9, _hoisted_7)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          (copy.value.action.kind === 'open')
            ? (_openBlock(), _createBlock(GlowFrame, {
                key: 0,
                subtle: "",
                "frame-class": "inline-flex rounded-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(NeueButton, {
                    type: "accent",
                    size: "md",
                    onClick: _unref(open)
                  }, {
                    "icon-right": _withCtx(() => [
                      _createVNode(SwooshArrow, { class: "ml-0.5" })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(copy.value.action.label) + " ", 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }))
            : (_unref(canCopy))
              ? (_openBlock(), _createBlock(NeueButton, {
                  key: 1,
                  type: "accent",
                  size: "md",
                  onClick: _unref(copyLink)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(copied) ? 'Copied' : copy.value.action.label), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : (_unref(url))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    href: _unref(url),
                    target: "_blank",
                    rel: "noopener noreferrer",
                    class: _normalizeClass(_unref(neueButtonClasses)({ type: 'accent', size: 'md' }))
                  }, " Preview your storefront ", 10, _hoisted_9))
                : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

}